// extracted by mini-css-extract-plugin
module.exports = {"EditTab":"EditTab_EditTab__RthOF","SwitchTab":"EditTab_SwitchTab__12ofe","tabbutton":"EditTab_tabbutton__3Inr_","active":"EditTab_active__3XaML","Content":"EditTab_Content__3dwWd"};